


export class GlobalIdGenerator {

    private static _instance: GlobalIdGenerator | null = null;

    private _globalId: number = 0;

    public static getInstance(){
        if(this._instance === null){
            this._instance = new GlobalIdGenerator()
        }
        return this._instance;
    }

    public generateId(): string {
        this._globalId++;
        return this._globalId.toString();
    }
}